import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Layout from './layouts/index';
import Index from './pages/index';
import AboutUs from './pages/about-us';
import Services from './pages/services';
import GalleryLA from './pages/gallery-la';
import GalleryDB from './pages/gallery-db';
import GalleryPL from './pages/gallery-pl';
import ContactUs from './pages/contact-us';
import NotFound from './pages/404';


ReactDOM.render(
  <BrowserRouter>
    <Layout>
      <Switch>
        <Route exact={true} path="/" component={Index}/>
        <Route path="/about-us/" component={AboutUs}/>
        <Route path="/services/" component={Services}/>
        <Route path="/gallery-la/" component={GalleryLA}/>
        <Route path="/gallery-db/" component={GalleryDB}/>
        <Route path="/gallery-pl/" component={GalleryPL}/>
        <Route path="/contact-us/" component={ContactUs}/>
        <Route component={NotFound}/>
      </Switch>
    </Layout>
  </BrowserRouter>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx